<ion-content class="ion-padding service-unavailable-content">
  <div class="service-unavailable-box">
    <h2>{{ 'ui.service.unavailable.service.unavailable.component.text.servicio_temporalmente_no_disponible' | translate }}</h2>
    <p>{{ 'ui.service.unavailable.service.unavailable.component.text.estamos_verificando_que_base_de_datos_y_almacenamiento_e' | translate }}</p>
    <ion-button (click)="retry()" [disabled]="checking">
      {{ checking
        ? ('ui.service.unavailable.service.unavailable.component.text.verificando' | translate)
        : ('ui.service.unavailable.service.unavailable.component.text.reintentar' | translate) }}
    </ion-button>
    <ion-text color="danger" *ngIf="message">{{ message }}</ion-text>
  </div>
</ion-content>
